var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import { Icon } from '../Icon';
import { Focusable } from '../Focusable';
import { createStyleSheet } from '../../utils';
import { useStyleSheet, useThemeContext } from '../../hooks';
export const IconTextButton = (_a) => {
    var { icon, text, onPress, style, type, disabled, isLoading } = _a, props = __rest(_a, ["icon", "text", "onPress", "style", "type", "disabled", "isLoading"]);
    const styles = useStyleSheet(getStyles);
    const { size, color } = useThemeContext();
    const iconSize = {
        xs: size.I,
        sm: size.J,
        md: size.J,
        lg: size.J
    };
    const iconColor = {
        primary: color.white.p100,
        secondary: color.primary.solid,
        tertiary: color.invert2.p68,
        quaternary: color.invert2.p100
    };
    const iconHoveredColor = {
        primary: color.white.p100,
        secondary: color.primary.solidHover,
        tertiary: color.invert2.p100,
        quaternary: color.invert2.p100
    };
    return (React.createElement(Focusable, { onPress: isLoading ? () => { } : onPress, style: [styles.container, style], disabled: disabled }, ({ hovered }) => (React.createElement(React.Fragment, null,
        React.createElement(View, { style: [
                styles.icon,
                styles[`icon__${props.size}`],
                hovered
                    ? styles[`container__${type}__hovered`]
                    : styles[`container__${type}`]
            ] }, isLoading ? (React.createElement(ActivityIndicator, { color: hovered ? iconHoveredColor[type] : iconColor[type], style: styles[`loadingIndicator__${props.size}`] })) : (React.createElement(Icon, { name: icon, size: iconSize[props.size], color: hovered ? iconHoveredColor[type] : iconColor[type] }))),
        React.createElement(Text, { style: [
                styles.text,
                hovered
                    ? styles[`text__${type}__hovered`]
                    : styles[`text__${type}`]
            ] }, text)))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    container__primary: {
        backgroundColor: color.primary.solid
    },
    container__secondary: {
        backgroundColor: color.primary.ghost
    },
    container__tertiary: {
        backgroundColor: color.invert2.p4
    },
    container__quaternary: {},
    container__primary__hovered: {
        backgroundColor: color.primary.solidHover
    },
    container__secondary__hovered: {
        backgroundColor: color.primary.ghostHover
    },
    container__tertiary__hovered: {
        backgroundColor: color.invert2.p10
    },
    container__quaternary__hovered: {
        backgroundColor: color.invert2.p10
    },
    icon__xs: { padding: size.C },
    icon__sm: {
        padding: size.C
    },
    icon__md: {
        padding: size.D
    },
    icon__lg: {
        padding: size.F
    },
    icon: {
        borderRadius: 9999,
        marginRight: size.C
    },
    text: {
        fontSize: 15,
        lineHeight: 19,
        fontWeight: '600',
        letterSpacing: -0.01
    },
    text__primary: {
        color: color.primary.solid
    },
    text__secondary: {
        color: color.primary.solid
    },
    text__tertiary: {
        color: color.invert2.p68
    },
    text__quaternary: {
        color: color.invert2.p100
    },
    text__primary__hovered: {
        color: color.primary.solidHover
    },
    text__secondary__hovered: {
        color: color.primary.solidHover
    },
    text__tertiary__hovered: {
        color: color.invert2.p100
    },
    text__quaternary__hovered: {
        color: color.invert2.p100
    },
    loadingIndicator__lg: {
        width: size.J,
        height: size.J
    },
    loadingIndicator__md: {
        width: size.J,
        height: size.J
    },
    loadingIndicator__sm: {
        width: size.J,
        height: size.J
    },
    loadingIndicator__xs: { width: size.I, height: size.I }
}));
//# sourceMappingURL=index.js.map